'use client';

import { Metadata } from 'next';
import { useEffect } from 'react';
import Link from 'next/link';

export const metadata: Metadata = {
  robots: {
    index: false,
    follow: false,
  },
};

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-stone-50">
      <div className="text-center max-w-md mx-auto px-6 py-12">
        {/* Error Icon */}
        <div className="mb-6">
          <svg
            className="w-24 h-24 mx-auto text-red-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        {/* Error Message */}
        <h1 className="text-3xl font-serif font-bold text-stone-800 mb-3">Something went wrong</h1>

        <p className="text-stone-600 mb-8">An unexpected error occurred while loading this page</p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={reset}
            className="inline-block px-8 py-3 bg-stone-800 text-white rounded hover:bg-stone-700 transition-colors"
          >
            Try again
          </button>

          <div className="flex gap-4 justify-center">
            <Link
              href="/"
              className="text-stone-600 hover:text-stone-800 text-sm transition-colors"
            >
              Go home
            </Link>
            <span className="text-stone-300">·</span>
            <Link
              href="/castles"
              className="text-stone-600 hover:text-stone-800 text-sm transition-colors"
            >
              Browse castles
            </Link>
          </div>
        </div>

        {/* Error Details (Development) */}
        {process.env.NODE_ENV === 'development' && error.message && (
          <div className="mt-8 p-4 bg-red-50 border border-red-200 rounded text-left">
            <p className="text-xs font-mono text-red-800 break-all">{error.message}</p>
          </div>
        )}
      </div>
    </div>
  );
}
